import styled from 'styled-components'

const Container = styled.span``

export default () => <Container>loading...</Container>
